import { publishEvent, Constants } from '@salesforce/scv-connector-base';
import type {
  RingIncomingCallEventPublisher,
  RingIncomingCallRequest,
} from '@usecases/ring-incoming-call.usecase';
import { CallResultGenerator } from '@main/generators/call-result.generator';
import { Logger } from '@main/utils/logger';
import { CallTypes } from '@entities/call';

export class RingIncomingCallPublisher
  implements RingIncomingCallEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(call: RingIncomingCallRequest): Promise<void> {
    const mapCallType = (type: CallTypes): Constants.CALL_TYPE => {
      return type === CallTypes.INBOUND
        ? Constants.CALL_TYPE.INBOUND
        : Constants.CALL_TYPE.OUTBOUND;
    };

    const callResult = CallResultGenerator.generate(
      call.id,
      mapCallType(call.type),
      call.from,
    );

    this.logger.info('Ringing call to SCV', {
      action: 'RingIncomingCall',
      ...call,
    });

    publishEvent({
      eventType: 'CALL_STARTED',
      payload: callResult,
      registerLog: false,
    });
  }
}
